import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
	esp: (
		`
		<div style="text-align: justify;">
		
			<p class="mb-3">
				N.R.: Vi estas nekonata aŭtoro, kiun legas neniu. 
				Kial okazas tio?
			</p>
			
			<p class="mb-3">
				T.A.: Mi estas nekonata aŭtoro, kiun neniu legas, neniu interesiĝas kaj neniu publikigas. 
				Verŝajne, miaj pensoj tiom ne kongruas kun la kutima pensmaniero, ke ili simple ne atingas la menson de averaĝa homo, 
				ne povas esti perceptitaj de ĝi. La menso de iu aparta persono ĉiam estas ia certa volumeno, plenigita de certa enhavaĵo. 
				Ni plenigas nian menson per ideoj samkiel la stomakon – per manĝaĵo. 
				Kaj same kiel la stomako digestas manĝaĵojn, la cerbo ricevas kaj digestas ideojn; ambaŭloke kaj restas io, kio nutras nian  personecon, 
				kaj io foriras al forĵetaĵoj, al fekaĵoj.
			</p>
			
			<p class="mb-3">
				Tamen, la homo nutras sin  nur per manĝeblaj aŭ principe manĝeblaj produktoj; sed okazas, ke iam li uzas produktojn venenajn, 
				kiuj mortigas lin. 
				Tio povas okazi aŭ erare, kiam oni manĝas nekonatajn aŭ similajn al konataj fungojn, berojn, iajn bestojn. 
				Aŭ intence, kiam homo deziras aŭ estas devigita sinmortigi (kiel, ekz., Sokrato). 
				Sed praktike ne okazas, ke homo manĝas tion, kio ĝenerale ne estas destinita por manĝi: ekz., cindron, lignaĵon, vakson… 
				Ĉio tio ankaŭ elvokas morton, kaj tiuj, kiuj faras tion, kutime estas frenezuloj: homoj kun aliigita, ŝanĝita menso. 
				Ili ne vivas en la mondo de homoj, ne obeas homajn leĝojn, kaj nature, tio elpuŝas ilin el la homa mondo al ilia propra, alia mondo. 
				Alia mondo en ambaŭ sencoj.
			</p>
			
			<p class="mb-3">
				La samo okazas en la kapoj: la averaĝa homo havas certan aron de atingeblaj, “manĝeblaj” ideoj, kaj aliaj, 
				malsimilaj ideoj same estas forpuŝataj kiel io nemanĝebla, nedigestebla, neebla por akcepto. 
				Kiel en neniu kapo venus ideo manĝi vaton aŭ sablon, t.e. neorganikajn substancojn, same al tiu kapo ne venus pensoj, ne bazitaj sur organika, 
				kutima, tereca mondpercepto. La bazo, la substrato por tiuj pensoj en averaĝa cerbo forestas.
			</p>
			
			<p class="mb-3">
				Sed ekzistas homoj, kiuj elŝiriĝas el tiu cirklo, disrompas tiun ŝelon, limigantan iliajn pensojn. 
				Tiuj homoj supreniĝas al nova ŝtupo, penetras en alian mondon, aŭ pli ĝuste, vastigas la areon de nia mondo. 
				Kaj rakontas pri ĝi al ni, montras ĝin al ni. Kompreneble, plimulto de ili, venenigite pro nemanĝeblaĵo, pereas. 
				Ili ankaŭ fariĝas frenezuloj - absoluta paralelo de l’ agado de menso kaj stomako! 
				– kaj gvidas grandajn religiajn (profeto Muhamado) aŭ aliajn revoluciojn. 
			</p>
			
			<p class="mb-3">
				Sed se en ili ne flagras la flamo de perforto, se ilin logas vivo de pensado, disvastigo de limoj de konscio – tiam ili fariĝas Kreantoj. 
				Ne filozofoj – ja iliaj nudaj ideoj restas nur nudaj ideoj, direktindaj vojoj; sed kiu bezonas la vojon de neniu iratan? 
				La direkto fariĝas vivanta, kiam ĝi pleniĝas de la vivo, kiam post filozofoj ĝin sekvas poetoj, verkistoj, pentristoj, muzikistoj ... 
			</p>
			
			<p class="mb-3">
				En nia tempo estas  Stanislav Lem, kiu malfermis aliajn leĝojn kaj nociojn de ekzistado (“Inter steloj nin atendas Nekonateco”). 
				Estas kantaŭtoro Mihail Ŝĉerbakov, per kunigita influo de teksto kaj muziko gvidanta nin al la lokoj, ankoraŭ ne konataj por nia konscio. 
				Estas komponisto A. Skrjabin, verkisto T. Mann…
			</p>
			
			<p class="mb-3">
				Sed ja kiom da malgrandaj, ne atingantaj la nivelon de geniuloj, sed ankaŭ sentantaj “ion” kaj penantai esprimi ion laŭeble de siaj fortoj! 
				Tamen, kaj fortoj moderaj, kaj pereo destinita por multaj sur tiu vojo, en tenebro, inter ŝtonoj kaj deklivoj, 
				sekvante nur apenaŭ videblan trajektorion alte en ĉielo. La irado palpante, en nokto. Sed lumas direkto, kaj iras homoj, 
				rompante al si la gambojn, tamen levinte la kapon al tio, kio montras la vojon supre.
			</p>
			
			<p class="mb-3">
				Nu jen, mi estas unu el tiuj irantoj.
			</p>
			
		</div>
		`
	)
}

const itemName = {
	esp: 'Fragmento el intervjuo de T.A. por neekzistanta revuo'
}

const itemDate = {
	esp: `28an de decembro 2024`
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemDate: itemDate.esp,
		itemContent: content.esp,
		itemAuthor: author.esp
	}
}

export default item;